import { fetchContentAsync } from "../counter/counterSlice";

export const getDescriptionFromParagraph = (xml) => {
  if (!xml) return "";
  let descriptionText = "";

  for (const child of xml.querySelector("p")?.childNodes || []) {
    if (child.nodeType === Node.TEXT_NODE) {
      descriptionText += child.textContent;
    }
  }
  return descriptionText?.replaceAll(";", "");
};

export const getDescriptionFromNote = (dartSelectors, xml, setCallback) => {
  if (!xml) return "";

  const conref = xml.querySelector("note")?.getAttribute("conref");
  if (conref) {
    const noteId = conref.split("#")[1].split("/")[1];
    fetchContentAsync(
      dartSelectors,
      "",
      "quicklinks/" + conref.replace("../", ""),
    ).then((noteContent) => {
      const parser = new DOMParser();
      const xml = parser.parseFromString(noteContent, "text/xml");
      setCallback(xml.getElementById(noteId)?.textContent.trim() || "");
    });
  }
};
